import { render } from "./VehicleSearch.vue?vue&type=template&id=5cdf276c&scoped=true"
import script from "./VehicleSearch.vue?vue&type=script&lang=js"
export * from "./VehicleSearch.vue?vue&type=script&lang=js"

import "./VehicleSearch.vue?vue&type=style&index=0&id=5cdf276c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdf276c"]])

export default __exports__